import React, { useState } from 'react';
import { HiChevronDoubleLeft } from "react-icons/hi2";
import { IoMdHome } from "react-icons/io";
import { FaSearchengin } from "react-icons/fa6";
import { Link, Route, Routes, useNavigate } from 'react-router-dom';
import logo from '../Image/logo.webp';
import Login from './Login';
import Signup from './Signup';
import { signOut } from "firebase/auth";
import { auth } from '../firebase';
import Pro from './Pro';
import UserWork from './UserWork';

function Home({ setIsLoggedIn, setUser, user }) {
  const [issidemenu, setissidemenu] = React.useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const navigate = useNavigate();

  const handleStartCoding = () => {
    if (user) {
      setIsLoggedIn(true);
      navigate('/newpro');
    } else {
      navigate('/home/login');
    }
  };

  const handleLogout = () => {
    signOut(auth)
      .then(() => {
        setUser(null);
        setIsLoggedIn(false);
        navigate("/home/signup");
        console.log("Signed out successfully");
      })
      .catch((error) => {
        // Handle error
      });
  };

  return (
    <>
      <div className={`w-2 ${issidemenu ? "w-2" : "flex-[.2] xl:flex-[.2]"} min-h-screen max-h-screen relative bg-secondary px-3 py-6 flex flex-col items-center justify-start gap-4 transition-all-duration-200 ease-in-out`}>
        <div onClick={() => { setissidemenu(!issidemenu) }} className="w-8 h-8 bg-secondary absolute -right-6 top-6 rounded-r-lg cursor-pointer flex items-center justify-center">
          <HiChevronDoubleLeft className="text-xl text-white font-semibold" />
        </div>

        <div className="overflow-hidden flex flex-col w-full gap-4">
          <Link to={'/home/projects'}><img src={logo} alt="Logo" className="object-contain w-72 h-auto" /></Link>

          <Link to={'/newpro'} onClick={handleStartCoding}>
            <div className="px-6 py-3 flex items-center justify-center rounded-xl border border-gray-400 cursor-pointer group hover:border-gray-200">
              <p className='text-gray-400 group hover:text-gray-200' >Start Coding</p>
            </div>
          </Link>

          {user && (
            <Link to={'/home/projects'} className='flex items-center justify-center gap-6 text-gray-400'>
              <IoMdHome className='text-xl cursor-pointer' />
              <p className='text-xl cursor-pointer'>Home</p>
            </Link>
          )}
        </div>
      </div>

      <div className="flex-1 min-h-screen max-h-screen overflow-y-scroll h-full flex flex-col items-start justify-start px-4 md:px-12 py-4 md:py-12">
        <div className="w-full flex flex-col md:flex-row items-center justify-between gap-3">
          <div className="w-full md:w-auto flex items-center justify-center md:justify-start bg-secondary px-4 py-3 rounded-md gap-3">
            <FaSearchengin className='text-2xl text-primaryText' />
            <input
              type='text'
              placeholder='Search here'
              className='text-xl border-none outline-none flex-1 px-4 py-1 bg-transparent text-primaryText placeholder:text-gray-600'
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </div>

          {!user ? (
            <div className="flex gap-3">
              <Link to={'/home/signup'} className='w-24 bg-emerald-500 py-3 px-4 text-center text-white rounded-md text-lg hover:bg-emerald-700 cursor-pointer'>
                Signup
              </Link>
              <Link to={'/home/login'} className='w-24 bg-secondary py-3 px-4 text-center text-white rounded-md text-lg hover:bg-emerald-700 cursor-pointer'>
                Login
              </Link>
            </div>
          ) : (
            <div className="flex gap-3">
              <Link to={'/home/userwork'} className='flex items-center justify-center gap-6 text-gray-400'>
                <p className='w-14 bg-emerald-400 py-3 px-4 text-center text-white rounded-xl text-2xl hover:bg-emerald-700 cursor-pointer capitalize'>
                  {user.email[0]}</p>
              </Link>
              <div className='flex items-center justify-center gap-6 text-gray-400' onClick={handleLogout}>
                <p className='w-24 bg-secondary py-3 px-4 text-center text-white rounded-md text-lg hover:bg-emerald-700 cursor-pointer'>Logout</p>
              </div>
            </div>
          )}
        </div>

        <div className="">
          <Routes>
            <Route path="/signup" element={<Signup setUser={setUser} />} />
            <Route path="/login" element={<Login setUser={setUser} />} />
            <Route path="/projects" element={<Pro user={user} setIsLoggedIn={setIsLoggedIn} searchQuery={searchQuery} />} />
            <Route path="/userwork" element={<UserWork user={user} setIsLoggedIn={setIsLoggedIn} searchQuery={searchQuery}/>} />
          </Routes>
        </div>
      </div>
    </>
  );
}

export default Home;
